import VoucherExplorer from "./VoucherExplorer";

export default VoucherExplorer;
